/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { Component } from 'react';
import DatePicker from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import { Input, Select } from '../../../../ui/Form';

import * as Styles from './index.styles';
import { Icon } from '../../../../ui/Icon';

// const yesterday = moment().subtract(1, 'day');
const yesterday = moment();
const disablePastDt = current => {
  if (current.isAfter(yesterday)) {
    return current.isoWeekday() !== 6 && current.isoWeekday() !== 7;
  } else {
    return false;
  }
};

const RenderDay = (props, currentDate, selectedDate) => {
  // console.log('** renderDay >> ', props);

  if (currentDate.isAfter(yesterday)) {
    if (currentDate.isoWeekday() === 6 || currentDate.isoWeekday() === 7) {
      props.className += ' weekend-date';
    }
  } else {
    props.className += ' past-date';
  }

  // Adds 0 to the days in the days view
  return (
    <td {...props}>
      <span {...props}>{currentDate.date()}</span>
    </td>
  );
};

export default class DateInput extends Component {
  selectedDateInCalendar;
  closeCalendar;
  state = {
    selectedData: '',
    isCalendarOpen: false,
  };

  onToggleCalendar = () => {
    this.setState({ isCalendarOpen: !this.state.isCalendarOpen });
  };

  getOverlay = () => {
    const { isCalendarOpen } = this.state;

    if (isCalendarOpen) {
      return <div css={Styles.overlay}></div>;
    }
    return false;
  };

  render() {
    const { selectedData } = this.state;
    const {
      // values,
      touched,
      errors,
      handleChange,
      SelectDateButtonText,
      // handleBlur,
      setFieldValue,
    } = this.props;

    return (
      <div css={Styles.dateform}>
        {this.getOverlay()}
        <DatePicker
          initialValue={selectedData}
          renderInput={(dProps, openCalendar, closeCalendar) => {
            this.selectedDateInCalendar = dProps.value;
            this.closeCalendar = closeCalendar;
            return (
              <div>
                <Input
                  // icon="chevron-down"
                  className="dateinputfield"
                  autocomplete="off"
                  id="date"
                  // onChange={handleChange}
                  onFocus={openCalendar}
                  value={selectedData}
                  defaultValue={selectedData}
                  placeholder={SelectDateButtonText}
                  error={errors.date && touched.date}
                  errorMessage={errors.date}
                  // className="inputfield"
                />
                <span
                  className="icon-holder"
                  css={Styles.iconChevronHolder}
                  onClick={openCalendar}
                  aria-hidden="true"
                >
                  <Icon name="chevron-down" />
                </span>
              </div>
            );
          }}
          renderView={(viewMode, renderCalendar) => {
            return (
              <div className="wrapper">
                {renderCalendar()}
                <div className="controls">
                  <button
                    type="button"
                    onClick={param => {
                      if (this.selectedDateInCalendar) {
                        this.setState({
                          selectedData: this.selectedDateInCalendar,
                        });
                        setFieldValue('date', this.selectedDateInCalendar);
                      }
                      this.closeCalendar();
                    }}
                  >
                    Select Date
                  </button>
                </div>
              </div>
            );
          }}
          renderDay={RenderDay}
          // onChange={value => {
          // console.log('** date change in cal', value);
          // }}
          initialViewMode="days"
          timeFormat={false}
          closeOnSelect={false}
          closeOnClickOutside={true}
          isValidDate={disablePastDt}
          autocomplete="off"
          onOpen={this.onToggleCalendar}
          onClose={this.onToggleCalendar}
        />
      </div>
    );
  }
}
